import { render, staticRenderFns } from "./FileUploadPreview.vue?vue&type=template&id=243dcd8b&"
import script from "./FileUploadPreview.vue?vue&type=script&lang=js&"
export * from "./FileUploadPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports